import _ from "lodash";
import React, { useContext, useState } from "react";

import { Ratio1Set, Zoomhanrei1Set } from "../../App";
// import { datasyousai, datakanren, brackboard } from './hanrei.module.css'
import ReactTooltip from "react-tooltip";

export function Hanreikakudai(props, csv) {
  const metadata = props.metadata;

  // const count = useContext(UserCount)
  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  // const [showm, setShowm] = useState(true)
  const [showm, setShowm] = useState(false);
  const [showh, setShowh] = useState(false);
  const [showtry, setShowtry] = useState(false);

  var hanrei_width = "0 0 960 650";

  function Syosai(props) {
    return (
      <>
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:mx-1 lg:mx-1">
            <div className="inline-block py-1 min-w-full">
              <div className="shadow-md sm:rounded-lg scroll-auto max-h-[50vh] ">
                <table className="min-w-full">
                  <caption>データ詳細</caption>
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th
                        scope="col"
                        className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                      ></th>
                      <th
                        scope="col"
                        className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                      >
                        高さ
                      </th>
                      <th
                        scope="col"
                        className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                      >
                        色
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        名称
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.title_height_name}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.title_color_name}
                      </td>
                    </tr>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        凡例名
                      </td>

                      {
                        <>
                          {" "}
                          {zoomhanrei1set[2].length == 8 && (
                            <>
                              <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                {metadata.hanrei_height_name}
                                {metadata.hanrei_height_name_2}
                                {metadata.hanrei_height_name_3}
                              </td>
                            </>
                          )}{" "}
                        </>
                      }

                      {
                        <>
                          {" "}
                          {zoomhanrei1set[2].length == 6 && (
                            <>
                              <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                {metadata.kokudo_hanrei_height_name}
                                {metadata.kokudo_hanrei_height_name_2}
                                {metadata.kokudo_hanrei_height_name_3}
                              </td>
                            </>
                          )}{" "}
                        </>
                      }

                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.hanrei_color_name}
                      </td>
                    </tr>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        年次
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.year_display}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.year_syousai}
                      </td>
                    </tr>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        出典
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.height_origin}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                        {metadata.color_origin}
                      </td>
                    </tr>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        定義
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 dark:text-gray-400  break-words">
                        {metadata.height_origin_note}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-500 break-words dark:text-gray-400">
                        {metadata.color_origin_note}
                      </td>
                    </tr>
                    <tr className="bg-white dark:bg-gray-800">
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        詳細
                      </td>
                      <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                        <a href={metadata.height_origin_url}>
                          {metadata.height_origin_url_name}
                        </a>{" "}
                        <br />
                        <a href={metadata.height_origin_url2}>
                          {metadata.height_origin_url2_name}
                        </a>
                        <br />
                        <a href={metadata.height_origin_url3}>
                          {metadata.height_origin_url3_name}
                        </a>
                        <br />
                        <a href={metadata.height_origin_url4}>
                          {metadata.height_origin_url4_name}
                        </a>
                      </td>
                      <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                        <a href={metadata.color_origin_url}>
                          {metadata.color_origin_url_name}
                        </a>
                        <br />
                        <a href={metadata.color_origin_url2}>
                          {metadata.color_origin_url2_name}
                        </a>
                        <br />
                        <a href={metadata.color_origin_url3}>
                          {metadata.color_origin_url3_name}
                        </a>
                        <br />
                        <a href={metadata.color_origin_url4}>
                          {metadata.color_origin_url4_name}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function Modal({ show, setShow }) {
    if (show) {
      return (
        <div
          id="overlay"
          onClick={() => setShow(false)}
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: " flex",
            alignItems: "center",
            justifyContent: " center",
          }}
          // className="pt-28 max-h-fit scroll-auto"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              zIndex: "10002",
              width: "95%",
            }}
            className="mt-[-15vh] text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg"
          >
            <div className="text-black">
              {/* <div> */}
              <div className="mx-auto">
                <Syosai post={metadata} />
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button onClick={() => setShow(false)}>閉じる</button>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  function Modalh({ show, setShow }) {
    if (show) {
      return (
        <div
          id="overlay"
          onClick={() => setShow(false)}
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",

            display: "flex",
            alignItems: " center",
            justifyContent: " center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              zIndex: "10002",
              width: "80%",
              padding: "1em",
              background: "#fff",
            }}
          >
            <div className="">
              <div>関連するデータへ</div>
              {metadata.tags == null ? null : (
                <div>
                  {metadata.tags.map((tag, index) => (
                    <div key={index}>
                      <a key={index} href={`/tgsl/${_.kebabCase(tag)}/`}>
                        # {`${tag}`}
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={{ textAlign: "center" }}>
              <button onClick={() => setShow(false)}>閉じる</button>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  function Modaltry({ show, setShow }) {
    if (show) {
      return (
        <div
          id="overlay"
          onClick={() => setShow(false)}
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",

            display: " flex",
            alignItems: " center",
            justifyContent: " center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              zIndex: "10002",
              width: "50%",
              // padding:"1em",
              background: "#fff",
            }}
          >
            <div className="" style={{ zIndex: "99" }}>
              {metadata.try}
              <div style={{ textAlign: "center" }}>
                <button onClick={() => setShow(false)}>閉じる</button>
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <button onClick={() => setShow(false)}>閉じる</button>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  // console.log(zoomhanrei1set);

  function googlemap() {
    var win;
    // var url = 'https://google.co.jp/maps/@' + zoomcount[0] + ',' + zoomcount[1]+ ',18z';
    var url =
      "http://maps.google.co.jp/maps?q=" +
      zoomhanrei1set[1] +
      "," +
      zoomhanrei1set[0];
    win = window.open(url, "gmap", "width=800,height=600");
  }

  return (
    <div>
      <div className="text-xl">
        <div
          className="bg-white/20 mt-2"
          data-tip={
            metadata.height_origin_note +
            "詳しくは「詳細を見る」ボタンを押してください。"
          }
        >
          <ReactTooltip
            effect="float"
            type="info"
            place="right"
            delayShow={0}
          />

          {
            <>
              {" "}
              {zoomhanrei1set[2].length == 8 && (
                <>
                  {metadata.hanrei_height_name}
                  <div className="text-sm">
                    {metadata.hanrei_height_name_2 && (
                      <>{metadata.hanrei_height_name_2}</>
                    )}
                    {metadata.hanrei_height_name_3 && (
                      <>{metadata.hanrei_height_name_3}</>
                    )}
                  </div>
                </>
              )}
            </>
          }

          {
            <>
              {" "}
              {zoomhanrei1set[2].length == 6 && (
                <>
                  {metadata.kokudo_hanrei_height_name}
                  <div className="text-sm">
                    {metadata.kokudo_hanrei_height_name_2 && (
                      <>{metadata.kokudo_hanrei_height_name_2}</>
                    )}
                    {metadata.kokudo_hanrei_height_name_3 && (
                      <>{metadata.kokudo_hanrei_height_name_3}</>
                    )}
                  </div>
                </>
              )}
            </>
          }
        </div>
        {zoomhanrei1set[3]}
      </div>
      {metadata.hanrei_height_name != metadata.hanrei_color_name && (
        <div className="text-xl">
          <div
            className="bg-white/20 mt-2"
            data-tip={metadata.color_origin_note}
          >
            <ReactTooltip
              effect="float"
              type="info"
              place="right"
              delayShow={1000}
            />
            {metadata.hanrei_color_name}
          </div>
          {!metadata.category_data && <>{zoomhanrei1set[4]}</>}
          {metadata.category_data && (
            <>
              {zoomhanrei1set[4] == 1 && <>{metadata.hanrei4_name}</>}
              {zoomhanrei1set[4] == 2 && <>{metadata.hanrei3_name}</>}
              {zoomhanrei1set[4] == 3 && <>{metadata.hanrei2_name}</>}
              {zoomhanrei1set[4] == 4 && <>{metadata.hanrei1_name}</>}
            </>
          )}
        </div>
      )}

      <div>
        <div className="bg-white/20 mt-2">メッシュコード</div>
        {zoomhanrei1set[2]}
      </div>

      {/* <div>
    <div className="bg-white/20 mt-2">
    緯度経度
    </div>
    {zoomhanrei1set[0]},{zoomhanrei1set[1]}
  </div> */}

      <div>
        <button
          onClick={googlemap}
          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-xs md:text-base lg:text-xl text-white rounded-lg group bg-gradient-to-br from-cyan-500/50 to-blue-500/50 group-hover:from-cyan-500/50 group-hover:to-blue-500/50 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200/50 dark:focus:ring-cyan-800/50 min-w-[10vw] m-1"
        >
          <span className="relative px-2.5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md group-hover:bg-opacity-0 pointer-events-auto min-w-[15vw] sm:min-w-[10vw]">
            場所を確認する
          </span>
        </button>
      </div>
      <div>
        <button
          onClick={() => setShowm(true)}
          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-xs md:text-base lg:text-xl text-white rounded-lg group bg-gradient-to-br from-cyan-500/50 to-blue-500/50 group-hover:from-cyan-500/50 group-hover:to-blue-500/50 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200/50 dark:focus:ring-cyan-800/50 min-w-[10vw] m-1"
        >
          <span className="relative px-2.5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md group-hover:bg-opacity-0 pointer-events-auto min-w-[15vw] sm:min-w-[10vw]">
            詳細を見る
          </span>
        </button>
      </div>

      <Modal show={showm} setShow={setShowm} />
      <Modalh show={showh} setShow={setShowh} />
      <Modaltry show={showtry} setShow={setShowtry} />
    </div>
  );
}
